var crSavePickupProperties = true;
var crDateCallback = function(picker, selectedStore, blackoutdatesCollection){
  var t = new Date()
  var currentDay = t.getDate();
  var currentMonth = t.getMonth();
  var currentyear = t.getFullYear();
  var weekDay = t.getDay();
  var currentHour = t.getHours();

  console.log({currentDay, currentMonth, currentyear})
  blackoutdatesCollection.push([2022, 1, 14, 'inverted'])
  if ((currentDay >= 12 && currentDay <= 13) && currentMonth === 1 && currentyear == 2022){
  //if ((currentDay >= 12 && currentDay <= 13) && currentMonth === 6 && currentyear == 2022){
	  picker.set('min', 3);
  }
  picker.set('disable', blackoutdatesCollection);
}

var crPickupCallback = function(timepicker, selectedStore, selectedDay, selectedDate, selectedMonth) {
  //console.log(selectedDay, selectedDate, selectedMonth);
  if(selectedDate.getDate() === 1 && selectedMonth === 6 && selectedDate.getFullYear() === 2022) {
  	timepicker.set('max',[13, 0]); 
  }
	
}